/* GOOBS Hero (class scoped) */
(function(){
  const sections = document.querySelectorAll('.goobs-hero');
  if(!sections.length) return;

  sections.forEach((root)=>{
    // Keyboard press feedback
    root.addEventListener('keydown',(e)=>{
      if(e.key===' '||e.key==='Enter'){
        const btn = e.target.closest('.gh-cta');
        if(btn) btn.classList.add('is-pressed');
        const wrap = btn?.closest('.gh-cta-wrap');
        if(wrap) wrap.classList.add('is-pressed');
      }
    });
    root.addEventListener('keyup',(e)=>{
      const btn = e.target.closest('.gh-cta');
      if(btn) btn.classList.remove('is-pressed');
      const wrap = btn?.closest('.gh-cta-wrap');
      if(wrap) wrap.classList.remove('is-pressed');
    });

    // Mouse/touch press fallback (so the wrap depth shortens even if :has isn't supported)
    root.querySelectorAll('.gh-cta').forEach((btn)=>{
      const wrap = btn.closest('.gh-cta-wrap');
      ['mousedown','touchstart'].forEach(ev =>
        btn.addEventListener(ev,()=>wrap?.classList.add('is-pressed'))
      );
      ['mouseup','mouseleave','touchend','touchcancel'].forEach(ev =>
        btn.addEventListener(ev,()=>wrap?.classList.remove('is-pressed'))
      );
    });

    // Arrow smooth scroll
    const arrow = root.querySelector('.ghero__arrow');
    if(arrow){
      arrow.addEventListener('click',(e)=>{
        e.preventDefault();
        const id = arrow.getAttribute('data-anchor') || 'benefits';
        const target = document.getElementById(id) || document.querySelector(`[name="${id}"]`);
        if(target){
          target.scrollIntoView({behavior:'smooth', block:'start'});
          if(history && history.replaceState) history.replaceState(null,'', `#${id}`);
        }
      });
    }
  });
})();




document.addEventListener("DOMContentLoaded", () => {
  const hotspot = document.querySelector(".ghero__hotspot");
  if (!hotspot) return;

  // We track both arms.
  const defaultArm = document.querySelector(".ghero__character-arm--default");
  const altArm     = document.querySelector(".ghero__character-arm--alt");

  // Helper: whichever arm is currently visible is the one we animate.
  function getActiveArm() {
    const altMode = document.querySelector(".goobs-hero")?.classList.contains("goobs-alt-mode");
    return altMode && altArm ? altArm : defaultArm;
  }

  let waveTimer = null;
  let currentAngle = 0;
  let returnAnimationFrame = null;

  function setAngle(angle) {
    currentAngle = angle;
    const arm = getActiveArm();
    if (arm) arm.style.transform = `rotate(${angle}deg)`;
  }

  function startWave() {
    if (returnAnimationFrame) cancelAnimationFrame(returnAnimationFrame);
    if (waveTimer) return;

    waveTimer = setInterval(() => {
      currentAngle = (currentAngle === 16 ? -8 : 16);
      const arm = getActiveArm();
      if (arm) arm.style.transform = `rotate(${currentAngle}deg)`;
    }, 140);
  }

  function smoothReturn() {
    function step() {
      const diff = 0 - currentAngle;
      const arm = getActiveArm();

      if (Math.abs(diff) < 0.5) {
        currentAngle = 0;
        if (arm) arm.style.transform = "rotate(0deg)";
        return;
      }

      currentAngle += diff * 0.18;
      if (arm) arm.style.transform = `rotate(${currentAngle}deg)`;

      returnAnimationFrame = requestAnimationFrame(step);
    }

    returnAnimationFrame = requestAnimationFrame(step);
  }

  function stopWave() {
    clearInterval(waveTimer);
    waveTimer = null;
    smoothReturn();
  }

  hotspot.addEventListener("mouseenter", startWave);
  hotspot.addEventListener("mouseleave", stopWave);

  // If user toggles alt-mode while waving,
  // ensure the new arm smoothly syncs to currentAngle.
  document.addEventListener("click", () => {
    const arm = getActiveArm();
    if (arm) arm.style.transform = `rotate(${currentAngle}deg)`;
  });
});




document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.querySelector(".ghero__character-wrap");
  const bodyImg = document.querySelector(".ghero__character");
  const armImg  = document.querySelector(".ghero__character-arm");

  if (!wrap || !bodyImg || !armImg) return;

  function checkLoaded() {
    if (bodyImg.complete && armImg.complete) {
      wrap.classList.remove("ghero__char-hidden");
      wrap.classList.add("ghero__char-loaded");
    }
  }

  // Check immediately (cached images)
  checkLoaded();

  // Fallback events
  bodyImg.addEventListener("load", checkLoaded);
  armImg.addEventListener("load", checkLoaded);
});


document.addEventListener("DOMContentLoaded", function () {
  const leftStar = document.querySelector('.ghero__star--left');
  const rightStar = document.querySelector('.ghero__star--right');
  const heroSection = document.querySelector('.goobs-hero');

  if (!heroSection) return;

function toggleAltMode() {
  const heroSection = document.querySelector('.goobs-hero');
  if (!heroSection) return;
  heroSection.classList.toggle('goobs-alt-mode');
}


  if (leftStar) {
    setTimeout(() => {
      leftStar.classList.add('ghero__star--animate');
    }, 600);
    leftStar.addEventListener('click', toggleAltMode);
  }

  if (rightStar) {
    setTimeout(() => {
      rightStar.classList.add('ghero__star--animate');
    }, 670);
    rightStar.addEventListener('click', toggleAltMode);
  }
});


  window.altCharacterImages = {
    body: "{{ section.settings.character_alt_image | image_url }}",
    arm:  "{{ section.settings.character_alt_arm_image | image_url }}"
  };

  document.addEventListener("DOMContentLoaded", () => {
    Object.values(window.altCharacterImages).forEach(src => {
      if (!src) return;
      const img = new Image();
      img.src = src;
    });
  });